<template>
    <div>
        <router-view v-show="$route.meta.hasOwnProperty('detail') && $route.meta.detail"></router-view>
        <div class="wrap" v-show="!$route.meta.hasOwnProperty('detail') || !$route.meta.detail">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ $route.meta.title }}
                            <el-button class="title_btn" type="primary" @click="$router.push('/feed/todaybanner/create')">배너 등록</el-button>
                            <div class="clear"></div>
                        </div>
                        <today-banner-component ></today-banner-component>
                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TodayBannerComponent from "@/components/todayBanner/TodayBannerComponent";

export default {
    name: "TodayBanner",
    mixins: [],
    components: {TodayBannerComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            // todayKey: this.$route.params.p_idx,
        }
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>

